import React from "react";
import { Search, Filter, Archive, X } from "lucide-react";

export function QuoteFilters({
  searchQuery,
  setSearchQuery,
  showArchived,
  setShowArchived,
  showFilters,
  setShowFilters,
  statusFilter,
  setStatusFilter,
  ownerFilter,
  setOwnerFilter,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  users,
  isAdmin,
  onClearFilters,
}) {
  const hasActiveFilters = searchQuery || statusFilter || ownerFilter || dateFrom || dateTo;

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 mb-6 shadow-sm">
      <div className="flex flex-wrap items-center gap-4">
        {/* Search */}
        <div className="relative flex-1 min-w-[250px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="search-input"
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by client, provider, or prepared by..."
            className="w-full h-10 pl-9 pr-4 rounded-lg border border-slate-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff] focus:ring-offset-1"
          />
        </div>
        
        {/* Quick Filters */}
        <div className="flex items-center gap-2">
          <button
            data-testid="toggle-archived-btn"
            onClick={() => setShowArchived(!showArchived)}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
              showArchived 
                ? "bg-amber-100 text-amber-700 border border-amber-200" 
                : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"
            }`}
          >
            <Archive size={14} />
            {showArchived ? "Viewing Archived" : "Show Archived"}
          </button>
          
          <button
            data-testid="toggle-filters-btn"
            onClick={() => setShowFilters(!showFilters)}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
              showFilters || hasActiveFilters
                ? "bg-[#3c68ff]/10 text-[#3c68ff] border border-[#3c68ff]/30"
                : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"
            }`}
          >
            <Filter size={14} />
            Filters
            {hasActiveFilters && (
              <span className="w-2 h-2 rounded-full bg-[#3c68ff]"></span>
            )}
          </button>
          
          {hasActiveFilters && (
            <button
              data-testid="clear-filters-btn"
              onClick={onClearFilters}
              className="flex items-center gap-1 px-2 py-2 text-sm text-slate-500 hover:text-slate-700"
            >
              <X size={14} />
              Clear
            </button>
          )}
        </div>
      </div>
      
      {/* Advanced Filters */}
      {showFilters && (
        <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="advanced-filters">
          <div>
            <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">Status</label>
            <select
              data-testid="status-filter"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff]"
            >
              <option value="">All Statuses</option>
              <option value="draft">Draft</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
          
          {isAdmin && (
            <div>
              <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">Created By</label>
              <select
                data-testid="owner-filter"
                value={ownerFilter}
                onChange={(e) => setOwnerFilter(e.target.value)}
                className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff]"
              >
                <option value="">All Users</option>
                {users.map(u => (
                  <option key={u.id} value={u.id}>{u.full_name}</option>
                ))}
              </select>
            </div>
          )}
          
          <div>
            <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">Date From</label>
            <input
              data-testid="date-from-filter"
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff]"
            />
          </div>
          
          <div>
            <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">Date To</label>
            <input
              data-testid="date-to-filter"
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff]"
            />
          </div>
        </div>
      )}
    </div>
  );
}
